import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import '../../../assets/css/siicex-usuario.css';
import React, { Component } from 'react';
import axios from 'axios';
import {API_URL,BASE_URL_RECURSOS} from '../../../constants';
import Error from '../../Error/error';
import {DropDownList} from '../../Elements/Select/dropdown';
import ThumbnailGrid from '../../Elements/Thumbnail/thumbnail';
import InComponentLoader from '../../Elements/Loader/componentloader';
import {updateValueInJson, ValidateArrayState} from '../../../functions';
import {ValidateState} from '../../../functions';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from 'moment';
import cookie from 'react-cookies';
import {toBase64} from '../../../functions';
import ImageUploader from 'react-images-upload';
import { Checkbox } from '@material-ui/core';

export default class edit_boletin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nNumero: '',
            resource: [],
            response: [],
            sectors: [],
            error: [],
            key: 0,
            incrementalKey:1000,
            added: true,
            security: cookie.load('user'),
            roles: [],
            // Image handling
            imagesToSelect: false,
            selectedImage: false,
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeDate = this.handleInputChangeDate.bind(this);
        // Image pagination control
        this.currentImagePage = 1;
      }

    GetSectors()
    {
        const urlBase  = `${API_URL}`
        axios.get(urlBase + 'MasterUX/6').then(response => response.data)
        .then((data) => {
            console.log(data);
            this.setState({ sectors: data.result});
        })
        .catch(error => {
            console.log(error);
        });
    }

    handleInputChangeDate(control){
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource['dFechaPublicacion'] = Moment(control).format();

         this.setState({
             resource: copyResource
        });
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource[target.name] = value;

        this.setState({
            resource: copyResource
        }, ()=> { 
          // console.log(this.state.resource) 
        });
    }

    componentDidMount(){
        this.getImages()
        this.GetSectors();

        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });

        var key = this.props.location.state.key;
        const url = `${API_URL}BulletinUX/${key}/1`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            console.log(data)

            let copyResource = JSON.parse(JSON.stringify(data.result));
            copyResource["cEstado"] = "B";
            copyResource["bActivo"] = "true";
            copyResource["Bole_NotificarPorPush"] = true;

            this.setState({ 
              resource: copyResource, 
              response: data, 
              error: data.Error }, ()=> { 
                this.setState({roles : roles}) 
              });

            if(document.querySelector('.loader')){
              document.querySelector('.loader').classList.add('loader--hide');
            }
            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            if(document.querySelector('.loader')){
              document.querySelector('.loader').classList.add('loader--hide');
            }
            toast.error("¡Error al consultar items!");
        });
    }

    handleClickCancel(e){
        const {history: {push}} = this.props;
        push('/boletin');
    }

    callFunctionButton = (event) => {

        // if (ValidateArrayState(this.state.resource, 'nSectorCodigo')) {  toast.error('Error en Validación: Escoja un Tipo de Sector.'); return; }
        if (ValidateState(this.state.resource, 'nSectorCodigo', '0')) {  toast.error('Error en Validación: Escoja un Tipo de Sector.'); return; }
        if (ValidateState(this.state.resource, 'sTitulo', '')) {  toast.error('Error en Validación: Ingrese un título de Boletín.'); return; }
        // if (ValidateState(this.state.resource, 'cEstado', '')) {  toast.error('Error en Validación: Escoja un Estado.'); return; }

        /*
          var nSectorCodigo   = this.state.resource.nSectorCodigo;
          var sector          = this.state.sectors.filter(function(x) {
            return x.nTipCodigo === nSectorCodigo.value
          });
        */

        const url           = `${API_URL}BulletinUX/`;
        var dataForm        = this.state.resource;

        let nSectorCodigo = dataForm.nSectorCodigo;
        console.log(nSectorCodigo);

        dataForm = updateValueInJson(dataForm,'Bole_NotificarPorPush', (this.state.resource.Bole_NotificarPorPush.value ? this.state.resource.Bole_NotificarPorPush.value : this.state.resource.Bole_NotificarPorPush));
        dataForm = updateValueInJson(dataForm,'nUsuarioCreacion', this.state.security.nUsuCodigo);
        dataForm = updateValueInJson(dataForm,'sUsuario', this.state.security.sUsuNombre + ' ' + this.state.security.sUsuApellidoPaterno);

        if(nSectorCodigo !== null && nSectorCodigo.value && nSectorCodigo.value.toString() !== "0"){
          // dataForm = updateValueInJson(dataForm,'sSector', sector[0].sTipNombre);
          // dataForm = updateValueInJson(dataForm,'nSectorCodigo', sector[0].nTipCodigo);

          dataForm = updateValueInJson(dataForm,'sSector', nSectorCodigo.label);
          dataForm = updateValueInJson(dataForm,'nSectorCodigo', nSectorCodigo.value);
        }else{
          dataForm = updateValueInJson(dataForm,'sSector', "");
          dataForm = updateValueInJson(dataForm,'nSectorCodigo', "");
        }

        dataForm    = updateValueInJson(dataForm,'cEstado', (this.state.resource.cEstado.value ? this.state.resource.cEstado.value : this.state.resource.cEstado));
        dataForm    = updateValueInJson(dataForm,'bActivo', (this.state.resource.bActivo.value ? this.state.resource.bActivo.value : this.state.resource.bActivo));

        // dataForm = updateValueInJson(dataForm,'cEstado', 'B');
        // dataForm = updateValueInJson(dataForm,'bActivo', true);

        const formData = JSON.stringify(dataForm);

        document.getElementById("btnGuardar").disabled = true;
        //console.log(dataForm);

        axios.post(
            url,
            JSON.stringify(formData),
                {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8' ,
                        'Accept': 'application/json'
                    }
        }).then((data)=> {
            if(document.querySelector('.loader')){
              document.querySelector('.loader').classList.add('loader--hide');
            }
            document.getElementById('content-wrapper').removeAttribute("hidden");

            console.log(data);

            if (data.data.isSucess)
            {
                toast.success('Boletin registrado correctamente');
                this.setState({added:false, loading: false, key: data.data.result.nBoletinCodigo});
                this.setState({resource:  updateValueInJson(this.state.resource, "nBoletinCodigo", data.data.result.nBoletinCodigo)});
                document.getElementById("btnGuardar").disabled = false;
                this.props.history.push({
                    pathname: '/boletin',
                    state: { key: data.data.result.nBoletinCodigo }
                    });
            } else
            {
                this.setState({loading:false});
                document.getElementById("btnGuardar").disabled = false;
                toast.error('No se pudo registrar el Boletin. \r');
            }
        }).catch((error)=> {
            toast.error('Error no controlado.');
            console.log(error);
            document.getElementById("btnGuardar").disabled = false;
            this.setState({loading:false});
        });
        
    }

    deleteImagen = (event) =>{
        this.setState({resource:  updateValueInJson(this.state.resource, "sFondo", null)});
    }

    onDrop=(picture)=>{
      if(picture.length<1) return;
      var file = picture[0];
      toBase64(file).catch(e => e).then(
        (data)=>
        {
          // Save as temp in state
          let _tmp = file
          _tmp.base64 = data;
          this.setState({selectedImage: _tmp});
        }
      );
    }

    // IMAGEN
    getImages(page=1){
      const urlBase  = `${API_URL}`
      axios.get(urlBase + `FileUX/0/${page}/imagenes/all/all/`).then(response => response.data)
      .then((data) => {
        this.currentImagePage = page
        this.setState({ imagesToSelect: data.result});
      }).catch(error => {
        console.error(error);
      });
    }
    selectImage = (img_obj) => {
      // Set this.state properties
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sFondo', img_obj.sArchivoRuta)
      _tmp = updateValueInJson(_tmp, 'nImagenCodigo', img_obj.nArchivoCodigo)
      this.setState({resource: _tmp}, () => {
        document.getElementById("thumbnail-modal-close").click();
      });
    }
    unSelectImage = () => {
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sFondo', null)
      _tmp = updateValueInJson(_tmp, 'nImagenCodigo', null)
      this.setState({resource: _tmp});
    }
    uploadImage = () => {
      let _file = this.state.selectedImage;
      let formData = {};
      let _filename = _file.name
      formData.sArchivoNombre = _filename;
      formData.sArchivoID = "03977376-4DEF-45BA-B810-934A55A6DA16"
      formData.sArchivoExtension = _filename.substring(_filename.lastIndexOf(".")+1, _filename.length)
      formData.sArchivoTipo = "imagenes"
      //formData.sCategoriaArchivo = "boletin"
      formData.sCategoriaArchivo = ""
      formData.sArchivoData = _file.base64;
      formData.nCodigoUsuario = this.state.security.nUsuCodigo;

      toast.info("Por favor espere mientras la imagen es procesada")
      axios.post((API_URL+`FileUX/`),
        ("'"+JSON.stringify(formData)+"'"),
        {
          headers: {
            'Content-Type': 'application/json; charset=UTF-8' ,
            'Accept': 'application/json'
          }
        }
      ).then( data => {
        toast.success("La imagen ha sido subida correctamente")

        // Select uploaded image
        let _tmp = {};
        _tmp = updateValueInJson(this.state.resource, 'sFondo', data.data.result.sArchivoRuta)
        _tmp = updateValueInJson(_tmp, 'nImagenCodigo', data.data.result.nArchivoCodigo)
        this.setState({resource: _tmp}, this.getImages());
      }).catch((error)=> {
        console.error(error);
        toast.error('Error al subir la imagen');
      });
    }
    imagePaginationTable(){
      // Get data
      let data = this.state.imagesToSelect.length!=0 ? this.state.imagesToSelect : false;
      if(!data){
        data = this.state.imagesToSelect;
        if(!data || data.length==0) return;
      }

      // Pagination calcs
      let totalPages = data[0].totalPages;
      let options = false;
      options = [];

      // Inicio button
      if(totalPages>2) options.push(<span id={"pagination-inicio"} key={"pagination-inicio"} onClick={() => this.getImages(1)}>Inicio </span>);
      // Index buttons
      for(let index=1; index<(totalPages+1); index++){
        if(index>10 && index%10!=0) continue;
        options.push(
          <span id={"pagination-"+index}
            key={"pagination-link-"+index}
            onClick={() => this.getImages(index)}
            className={index===this.currentImagePage?"active":""}>
              {index}
          </span>
        );
      }
      // Fin button
      if(totalPages>2) options.push(<span id={"pagination-fin"} key={"pagination-fin"} onClick={() => this.getImages(totalPages)}>Fin </span>);

      return (
        <div className="pagination" key={"pagination"}>
          {options}
        </div>
      );
    }

    render() {
        // console.log(this.state.resource);

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        return (
                (this.state.response.statusCode===200)?
                (
                    <div id="detailBody" className="Site-content" >
                        <div className="loader"></div>
                        <form id="frmResource" name="frmResource" onSubmit={this.handleClickSubmit} >
                            <input type="hidden" id="dFechaModificacion" name="dFechaModificacion" defaultValue={this.state.resource.dFechaModificacion} />
                            <input type="hidden" id="nUsuarioModificacion" name="nUsuarioModificacion" defaultValue={this.state.resource.nUsuarioModificacion} />
                            <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <div id="Body" className="body-container container-fluid">
                                    <div className="content-option">
                                         <div className="row ">

                                            <div className="col-md-6">
                                                <div className="boletin__filters section__margin-bottom">
                                                    <div className="form-group">
                                                        <label htmlFor="nBoletinCodigo"><strong>Código</strong></label>
                                                        <input type="text" readOnly name="nBoletinCodigo" onChange={this.handleInputChange} id="nBoletinCodigo" defaultValue={this.state.resource.nBoletinCodigo} className="form-control text-filter__form-control" placeholder="Código" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="nSectorCodigo"><strong>Sector</strong></label>
                                                        <div className="col-sm-12">
                                                            <DropDownList 
                                                              isMulti={false} 
                                                              tipo={"master"} 
                                                              // filtro={this.state.roles}  
                                                              name="nSectorCodigo" 
                                                              metodo={"add"} 
                                                              valor={0}
                                                              etiqueta={"Seleccione una Opción de la Lista"} 
                                                              onChange={this.handleInputChange} 
                                                              id="nSectorCodigo" 
                                                              clave={this.state.resource.nSectorCodigo} 
                                                              componente={"Sector"} 
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="sTitulo"><strong>Título</strong></label>
                                                        <input type="text" name="sTitulo" id="sTitulo" onChange={this.handleInputChange} defaultValue={this.state.resource.sTitulo} className="form-control text-filter__form-control" placeholder="Título" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="sDescripcion"><strong>Descripcion</strong></label>
                                                        <input type="text" name="sDescripcion" id="sDescripcion" onChange={this.handleInputChange} defaultValue={this.state.resource.sDescripcion} className="form-control text-filter__form-control" placeholder="Descripcion" />
                                                    </div>
                                                    <div className="form-group">
                                                         <label ><strong>Fecha de Publicación</strong></label>
                                                        <br/>
                                                         <DatePicker className="form-control text-filter__form-control col-md-12" onChange={this.handleInputChangeDate}  value={this.state.resource.dFechaPublicacion}/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="cEstado"><strong>Estado</strong></label>
                                                        <div className="">
                                                            <DropDownList 
                                                              metodo={"add"} 
                                                              valor={"B"} 
                                                              etiqueta={"Seleccione una Opción de la Lista"} 
                                                              name="cEstado" 
                                                              id="cEstado" 
                                                              onChange={this.handleInputChange} 
                                                              clave={this.state.resource.cEstado} 
                                                              componente={"EstadoBoletin"} 
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="bActivo"><strong>Activo</strong></label>
                                                        <div className="">
                                                            <DropDownList 
                                                              metodo={"add"} 
                                                              valor={"true"} 
                                                              etiqueta={"Seleccione una Opción de la Lista"} 
                                                              className="form-control text-filter__form-control" 
                                                              name="bActivo" 
                                                              id="bActivo" 
                                                              onChange={this.handleInputChange} 
                                                              clave={this.state.resource.bActivo} 
                                                              componente={"Activo"} 
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="Bole_NotificarPorPush">
                                                            <Checkbox  
                                                                name="Bole_NotificarPorPush" 
                                                                id="Bole_NotificarPorPush" 
                                                                onChange={this.handleInputChange} 
                                                                // value={this.state.resource.Bole_NotificarPorPush} 
                                                                placeholder="Notificar por push" 
                                                                checked={this.state.resource.Bole_NotificarPorPush}
                                                            />
                                                            <label htmlFor="Bole_NotificarPorPush">
                                                              <strong>Notificar por push</strong>
                                                          </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="boletin__filters section__margin-bottom">
                                                    {/* Subir imagen */}
                                                    <div className="form-group">
                                                        <label htmlFor="sFondo"><strong>Imagen Fondo Tamaño (1400 x 456)</strong></label>
                                                        <ImageUploader
                                                          onChange={this.onDrop} withIcon={true} id="Uploader"
                                                          label="Formatos aceptados: JPEG - JPG - GIF - PNG"
                                                          imgExtension={['.jpg', '.gif', '.png', '.gif']}
                                                          singleImage={true} withPreview={true}
                                                          buttonText='Click para elegir imagen'
                                                          maxFileSize={5242880} />
                                                          <button disabled={!this.state.selectedImage}
                                                            type="button" className="btn btn-primary btn-primary__tool"
                                                            onClick={this.uploadImage}>
                                                              SUBIR Y SELECCIONAR
                                                          </button>
                                                    </div>
                                                    {/* Seleccionar imagen */}
                                                    <div className="form-group">
                                                        {/* Show thumbnail modal button */}
                                                        <button
                                                          type="button" className="btn btn-primary btn-primary__tool"
                                                          data-toggle="modal" data-target="#thumbnail-modal">
                                                            {this.state.resource.sFondo?"CAMBIAR":"SELECCIONAR DE SERVIDOR"}
                                                        </button>
                                                    </div>
                                                    {/* Vista previa */}
                                                    <div className="boletin__filters section__margin-bottom">
                                                        {!this.state.resource.sFondo
                                                          ? (<h6>No se ha seleccionado ninguna imagen</h6>)
                                                          : (
                                                            <div>
                                                              <img className="col-md-12"
                                                                src={BASE_URL_RECURSOS+this.state.resource.sFondo} />
                                                              <br/><br/>
                                                              <button
                                                                type="button" className="btn btn-primary btn-primary__tool"
                                                                onClick={this.unSelectImage}>
                                                                  Eliminar
                                                              </button>
                                                            </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <br/>
                                            </div>

                                            {/* 
                                            <div className="col-md-4">
                                                <h5 className="text-danger"><strong>Resumen de Boletín</strong></h5>
                                                <ul>
                                                    <li className="text-danger" hidden={(this.state.resource.nSectorCodigo ? true : false)}> No ha escogido el sector de Boletín (Obligatorio)</li>
                                                   
                                                    <li className="text-danger" hidden={typeof this.state.resource.sTitulo === "string" && this.state.resource.sTitulo.trim().length>0}> No ha ingresado el titulo de Boletín (Obligatorio)</li>
                                                    <li className="text-danger" hidden={typeof this.state.resource.sDescripcion === "string" && this.state.resource.sDescripcion.trim().length>0}> No ha ingresado descripción del Boletín</li>
                                                    <li className="text-danger" hidden={(this.state.resource.cEstado? true : false)}> No se ha escogido estado</li>
                                                    <li className="text-danger" hidden={(this.state.resource.bActivo? true : false)}> Debe poner Activo o Inactivo el Boletín</li>
                                                    <li className="text-danger" hidden={(this.state.resource.sFondo?  true : false)}> No se ha escogido una imagen de fondo</li>
                                                </ul>
                                            </div>
                                            */}

                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" onClick={(event) => this.handleClickCancel(event)} className="btn btn-default btn-primary__submit">Cancelar</button>
                                                &nbsp;
                                                <button id="btnGuardar" type="button" onClick={(event) => this.callFunctionButton(event)} className="btn btn-primary btn-primary__submit">Guardar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </form>

                        {/* Thumbnail MODAL */}
                        <div className="modal fade" id="thumbnail-modal" tabIndex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                          <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                              <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>

                              <div className="modal-body modal-subscription__body">
                                <p className="modal-subscription__title">Imagenes</p>

                                <p className="modal-subscription__info">
                                  <div className="recursos__wrapper-table">
                                    {/* Content */}
                                    {this.state.imagesToSelect
                                      ? <ThumbnailGrid
                                          selectImage={this.selectImage}
                                          img_links={this.state.imagesToSelect}
                                          changePage={this.getImages}
                                          sizeX={"150px"} sizeY={"150px"} />
                                      : <InComponentLoader show={true} message={"Se está generando el Boletín HTML espere un momento"} />
                                    }
                                  </div>
                                </p>
                                {this.imagePaginationTable()}
                              </div>

                              <div className="modal-footer">
                                <button id="thumbnail-modal-close" type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                  <i className="fas fa-close fa-sm"></i> &nbsp;
                                  <span>Cerrar</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                )
                :
                (
                    <Error StatusCode="500" StatusMessage="Error"></Error>
                )
                );
    }
}
